import { ApiFragment } from '../../record/entities/api-fragment.entity';

export enum ScanItemState {
    Initial,
    Loading,
    Accepted,
    Rejected
}

export type ScanItem = BaseScanItem | CompletedScanItem | PendingScanItem | FailedScanItem | InitialScanItem;

export interface BaseScanItem {
    id: string;
    state: ScanItemState;
    record?: ApiFragment;
    index?: number;
    errorMsg?: string;
}

export interface CompletedScanItem extends BaseScanItem {
    id: string;
    state: ScanItemState.Accepted;
    record: ApiFragment;
}

export interface PendingScanItem extends BaseScanItem {
    id: string;
    state: ScanItemState.Loading;
}

export interface FailedScanItem extends BaseScanItem {
    id: string;
    state: ScanItemState.Rejected;
    record?: ApiFragment;
    errorMsg: string;
}

export interface InitialScanItem extends BaseScanItem {
    id: string;
    state: ScanItemState.Initial;
}
